export const generateDataObject = (modelStart, modelEnd) => {
    const [startYear, startMonth] = modelStart.split('-').map(Number);
    const [endYear, endMonth] = modelEnd.split('-').map(Number);
  
    const result = [];
  
    for (let year = startYear; year <= endYear; year++) {
      const data = {};
  
      const start = year === startYear ? startMonth : 1;
      const end = year === endYear ? endMonth : 12;
  
      for (let month = 1; month <= 12; month++) {
        const key = `month_${String(month).padStart(2, '0')}`;
        data[key] = month >= start && month <= end ? '' : null;
      }
  
      result.push({ year, data });
    }
  
    return result;
  };